import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-776253fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row q-mb-lg text-dark" }
const _hoisted_2 = { class: "col no-padding" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "col q-mb-lg text-bold" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  class: "col-xs-12 col-md-8 col-lg-5 q-mt-md Rotis text-white bg-secondary print-bg row justify-start items-center q-px-md",
  style: {"height":"45px"}
}
const _hoisted_8 = { class: "text-h6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"30px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1))
const _hoisted_10 = { class: "row items-center q-py-xs gt-xs" }
const _hoisted_11 = { class: "col no-padding" }
const _hoisted_12 = { class: "row center items-start q-pt-md q-pb-sm bg-primary text-white" }
const _hoisted_13 = { class: "col-3 q-px-sm txt-ellips left text-bold" }
const _hoisted_14 = { class: "col-2 q-px-sm txt-ellips text-bold" }
const _hoisted_15 = { class: "col-md-6 col-sm-7 col-xs-7 row items-end" }
const _hoisted_16 = { class: "col-5 q-px-sm" }
const _hoisted_17 = { class: "column justify-end" }
const _hoisted_18 = { class: "col txt-ellips" }
const _hoisted_19 = { class: "col-7 q-px-sm" }
const _hoisted_20 = { class: "column justify-end txt-ellips text-bold" }
const _hoisted_21 = { class: "col txt-ellips" }
const _hoisted_22 = { class: "row items-end" }
const _hoisted_23 = { class: "col border-right txt-ellips" }
const _hoisted_24 = { class: "col txt-ellips" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col static no-padding" })
], -1))
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col no-padding" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GreenTitle = _resolveComponent("GreenTitle")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_ResultsKompat4 = _resolveComponent("ResultsKompat4")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.perfusionWay === 'coinfusion' ? 'Infusion.InLine.Title' : 'Infusion.InContainer.Title').toUpperCase()), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('Compatibility.PhysicoChemicalCompatibility.' + (_ctx.perfusionWay === 'coinfusion' ? 'InLineParagraph' : 'InContainerParagraph'))), 1)
        ])
      ])
    ]),
    _createVNode(_component_GreenTitle, {
      title: _ctx.$t('Compatibility.PhysicoChemicalCompatibility.CarrierSolution')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.transport.name), 1)
      ])
    ]),
    _hoisted_9,
    _createVNode(_component_GreenTitle, {
      title: _ctx.$t('Compatibility.PhysicoChemicalCompatibility.MedSolution')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createTextVNode(_toDisplayString(_ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.TradeNameAddition')) + " ", 1),
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.TradeNameAddition')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createTextVNode(_toDisplayString(_ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.ActiveIngredient')) + " ", 1),
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.ActiveIngredient')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.MixingRatio')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.Compatibility')), 1),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, "   " + _toDisplayString(_ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.DirectDetails')), 1),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t(_ctx.perfusionWay === 'coinfusion' ? 'Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.Indirect60' : 'Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.Indirect24')), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass('col-md-1 '+(_ctx.$q.screen.sm ? 'hidden': '')+' row justify-end q-pr-md no-print text-bold text-right')
          }, _toDisplayString(_ctx.isOpen > 0 ? _ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.CloseDetails') : _ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.OpenDetails')), 3)
        ])
      ])
    ]),
    _hoisted_25,
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabOfSelectedMeds, (meds) => {
          return (_openBlock(), _createElementBlock("div", {
            key: meds.id,
            class: "no-page-break"
          }, [
            _createVNode(_component_ResultsKompat4, {
              selectedMeds: _ctx.tabOfSelectedMeds,
              med: meds,
              perfusionWay: _ctx.perfusionWay,
              transport: _ctx.transport,
              onSetIsOpen: _cache[0] || (_cache[0] = (value) => _ctx.isOpen += value ? 1 : -1)
            }, null, 8, ["selectedMeds", "med", "perfusionWay", "transport"])
          ]))
        }), 128))
      ])
    ])
  ]))
}